import React from "react";

/**
 * Compact usage indicator shown near the upload zone.
 * Props: { used, limit, plan }
 */
export default function UsageBadge({ used, limit, plan }) {
  // Hide during unlimited-testing mode (limit set very high)
  if (typeof limit === "number" && limit >= 1000) return null;

  if (plan && plan !== "free") {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#1D9E75]/10 border border-[#1D9E75]/30"
        data-testid="usage-badge"
      >
        <span className="w-1.5 h-1.5 bg-[#1D9E75]" />
        <span className="text-[11px] uppercase tracking-[0.22em] text-[#1D9E75] font-bold">
          Pro · Unlimited
        </span>
      </div>
    );
  }

  const remaining = Math.max((limit || 5) - (used || 0), 0);
  const pct = Math.min(((used || 0) / (limit || 5)) * 100, 100);
  const colour = remaining === 0 ? "#E24B4A" : remaining <= 1 ? "#BA7517" : "#1D9E75";

  return (
    <div
      className="flex items-center gap-3 px-3 py-2 bg-[#161620] border border-[#2A2A35]"
      data-testid="usage-badge"
    >
      <div className="flex items-center gap-2 font-mono-num text-sm">
        <span className="text-[#F0EDE8]">
          {used || 0}
          <span className="text-[#555]">/{limit || 5}</span>
        </span>
        <span className="text-[10px] uppercase tracking-[0.22em] text-[#888] font-bold">
          free uploads used
        </span>
      </div>
      <div className="w-20 h-1 bg-[#0A0A0F] overflow-hidden">
        <div
          className="h-full transition-all duration-500"
          style={{ width: `${pct}%`, background: colour }}
        />
      </div>
    </div>
  );
}
